/* Debouncing wrapper for any functions */
export function debounce<T extends unknown[]>(fn: (...args: T) => void, debounceTime = 0) {
    let timer: NodeJS.Timeout;

    return (...args: T) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn(...args), debounceTime);
    };
}
